import { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { Button, Box } from "@mui/material";

export default function VerifyEmail() {
	const [searchParams] = useSearchParams();
	const [message, setMessage] = useState("Verifying...");
	const hasFiredRef = useRef(false); // Use ref to track request status

	useEffect(() => {
		const token = searchParams.get("token");
		if (!token) {
			setMessage("Invalid verification link.");
			return;
		}

		if (hasFiredRef.current) return; // Prevent duplicate execution

		hasFiredRef.current = true; // Mark as fired before making the request

		async function verifyToken() {
			try {
				await axios.post(
					`${process.env.REACT_APP_SUPABASE_URL}/functions/v1/verify-email`,
					{ token },
					{
						headers: {
							"Content-Type": "application/json",
							Authorization: `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}`,
						},
					}
				);
				setMessage("Email verified successfully!");
			} catch (error) {
				setMessage("Verification failed. Please try again.");
			}
		}

		verifyToken();
	}, [searchParams]);

	return (
		<div style={{ textAlign: "center", marginTop: "50px" }}>
			<Box
				display="flex"
				flexDirection="column"
				alignItems="center"
				padding={2}
			>
				<h1>{message}</h1>
			</Box>
			{message === "Email verified successfully!" && (
				<Box
					display="flex"
					flexDirection="column"
					alignItems="center"
					padding={2}
				>
					<Button
						variant="contained"
						color="primary"
						onClick={() => {
							window.location.href = "/login";
						}}
					>
						Login
					</Button>
				</Box>
			)}
		</div>
	);
}
